import React, { useState } from 'react';
import './feedbackLabels.css';

const feedbackCategories = [
    { id: 'unclear', icon: '❓', labelKey: 'unclearLabel', type: 'NOK' },
    { id: 'incomplete', icon: '📝', labelKey: 'missingLabel', type: 'NOK' },
    { id: 'technical', icon: '🔧', labelKey: 'technicalLabel', type: 'OK' },
    { id: 'useful', icon: '✅', labelKey: 'usefulLabel', type: 'OK' },
];

const FeedbackLabels = ({ onSubmit, translations, disabled }) => {
    const [selectedLabel, setSelectedLabel] = useState(null);
    const [feedbackText, setFeedbackText] = useState('');

    const handleLabelClick = (category) => {
        if (disabled) return;
        
        // Toggle selection: if already selected, deselect; otherwise select this one
        setSelectedLabel(prev => prev === category.id ? null : category.id);
        if (selectedLabel !== category.id) {
            setFeedbackText('');
        }
    };

    const handleSubmit = () => {
        if (selectedLabel) {
            onSubmit(selectedLabel, feedbackText);
            setSelectedLabel(null);
            setFeedbackText('');
        }
    };

    const handleCancel = () => {
        setSelectedLabel(null);
        setFeedbackText('');
    };

    return (
        <div className="feedback-labels-wrapper">
            <div className="feedback-title">
                {translations.feedbackTitle || "Help us improve by rating your experience"}
            </div>
            <div className="feedback-labels-container">
                {feedbackCategories.map((category) => (
                    <div
                        key={category.id}
                        className={`feedback-label-item ${selectedLabel === category.id ? 'selected' : ''} ${disabled ? 'disabled' : ''}`}
                        onClick={() => handleLabelClick(category)}
                    >
                        <span className="feedback-label-icon">{category.icon}</span>
                        <span className="feedback-label-text">
                            {translations[category.labelKey] || category.id}
                        </span>
                    </div>  
                ))}
            </div>
            {selectedLabel && (
                <div className="feedback-text-section">
                    <textarea
                        className="feedback-textarea"
                        placeholder={translations.feedbackPlaceholder || 'Add more details (optional)...'}
                        value={feedbackText}
                        onChange={(e) => setFeedbackText(e.target.value)}
                        rows={3}
                        disabled={disabled}
                    />
                    <div className="feedback-buttons">
                        <button 
                            className="feedback-cancel-btn"
                            onClick={handleCancel}
                        >
                            {translations.cancel || "Cancel"}
                        </button>
                        <button 
                            className="feedback-submit-btn"
                            onClick={handleSubmit}
                        >
                            {translations.submit || "Submit"}
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default FeedbackLabels;